







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { routeName } from '@/constants/route.constants';
import AuthenticationModule, {
  AUTHENTICATION_MODULE_NAME
} from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { mapState } from 'vuex';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';

const authModule: AuthenticationModule = getModule(AuthenticationModule, store);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider
  },
  computed: {
    ...mapState(AUTHENTICATION_MODULE_NAME, [
      'customerLoginTokenRequestSuccess',
      'showButtonLoading',
      'errorResponse'
    ])
  }
})
export default class OwnerAccessComponent extends Vue {
  public customerLoginTokenRequestSuccess: boolean | null;
  public showButtonLoading: boolean;
  public errorResponse: BaseAPIErrorModel | null;
  public email = '';
  public accessCode = '';
  public verifyStage = false;

  public $refs: {
    form: HTMLFormElement;
  };

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async onSubmitEmailClick() {
    const success: boolean = await this.$refs.form.validate();

    if (!success) {
      return;
    }

    await authModule.customerLoginTokenRequestAction({ email: this.email });

    if (!this.errorResponse && this.customerLoginTokenRequestSuccess) {
      this.$toasted.success('An email has been sent with your access code.');
      this.verifyStage = true;
      this.$refs.form.reset();
    }
  }

  public async onVerifyClick() {
    const success: boolean = await this.$refs.form.validate();

    if (!success) {
      return;
    }

    await authModule.loginAction({
      email: this.email,
      password: this.accessCode,
      isCustomer: true
    });

    if (!this.errorResponse) {
      await authModule.authenticateOwnerAction(true);

      this.$router.replace({
        name: routeName.public.editCustomer
      });
    }
  }

  public async onCancelClick() {
    await authModule.resetOwnerAuthenticationAction();

    this.$router.replace({ name: routeName.public.customer });
  }
}
